import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpInterceptor } from '@angular/common/http';
import { catchError, from, Observable, switchMap } from 'rxjs';
import { StorageService } from '../../../service';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../../service/common/common.service';
import { IS_SHOW_LOADER } from '../../../lib/custom-context';
@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {
  constructor(private storageService: StorageService, private msalService: MsalService) { }

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  // CommonService.showLoader();
  const isShowLoader = req.context.get(IS_SHOW_LOADER);
  
  if(isShowLoader){
    CommonService.showLoader();
  }

  const isManual = localStorage.getItem('manual-logged-in') === 'true';

  if (isManual) {
    const manualToken = localStorage.getItem('manual-auth-token');
    if (manualToken) {
      const cloned = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${manualToken}`)
          .set('Content-Type', 'application/json')
      });
      return next.handle(cloned);
    } else {
      console.warn('[Manual Login] No manual token found.');
      const cloned = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
      return next.handle(cloned);
    }
  }

  let account: AccountInfo | null = this.msalService.instance.getActiveAccount();

  if (!account) {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      account = accounts[0];
      this.msalService.instance.setActiveAccount(account);
    }
  }

  if (!account) {
    console.warn('[SSO Login] No MSAL account found.');
    const cloned = req.clone({
      headers: req.headers.set('Content-Type', 'application/json')
    });
    return next.handle(cloned);
  }

  return from(
    this.msalService.instance.acquireTokenSilent({
      account,
      scopes: environment.client_sso.bridgenet.sso.scopes
    })
  ).pipe(
    switchMap((result) => {
      const token = result.accessToken;
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
      }
      localStorage.setItem('token', token);
      const cloned = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${token}`)
          .set('Content-Type', 'application/json')
      });
      return next.handle(cloned);
    }),
    catchError((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn('[SSO Login] Interaction required:', error);
      }
      const cloned = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
      return next.handle(cloned);
    })
  );
}

}


